<script setup>
// 快捷方块数据
const props = defineProps({
    quick: {
        type: Array,
        required: true,
        default: () => [],
    },
})
</script>

<template>
    <!-- 快捷方块1 -->
    <div class="Heziyun-blockBackground">
        <div class="Heziyun-quick">
            <a :href="item.url" class="Heziyun-itemBlock" v-for="(item, index) in quick" :key="item.id"
                v-intersect="{ class: 'bottom-top', delay: index * 40 }">
                <div class="Heziyun-neirong">
                    <div class="Heziyun-picture">
                        <a-image :src="item.img" show-loader :preview="false" />
                    </div>
                    <div class="Heziyun-text">
                        <span>{{ item.title }}</span>
                        <p>{{ item.tips }}</p>
                    </div>
                </div>
                <div class="Heziyun-buy">立即前往</div>
            </a>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 快捷方块1
.Heziyun-blockBackground {

    .Heziyun-quick {
        width: 100%;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        z-index: 10;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 1px;
        flex-wrap: wrap;

        .Heziyun-itemBlock {
            height: 6rem;
            width: 15rem;
            overflow: hidden;
            position: relative;
            background-color: #ffffff6e;
            flex-wrap: wrap;
            backdrop-filter: blur(10px);

            &:not(:last-child)::after {
                content: "";
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 100%;
                opacity: .1;
                background-color: #061a3d;
            }

            &:hover {
                background-color: #fff;
                height: 7.5rem;

                .Heziyun-background {
                    opacity: 1;
                }



                .Heziyun-neirong {
                    .Heziyun-picture {
                        transform: scale(1.1);
                        -webkit-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                        -ms-transform: scale(1.1);
                        -o-transform: scale(1.1);
                    }
                }
            }

            .Heziyun-neirong {
                position: relative;
                height: 6rem;
                padding: 1rem;
                display: flex;
                align-items: center;
                gap: 1rem;

                .Heziyun-picture {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    :deep(.arco-image-img) {
                        width: 2rem;
                        height: 2rem;
                        object-fit: contain;
                    }
                }

                .Heziyun-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.3rem;

                    span {
                        color: #111827;
                        font-size: 0.95rem;
                        display: -webkit-box;
                        /* 将元素设置为弹性盒子 */
                        -webkit-box-orient: vertical;
                        /* 设置内容垂直排列 */
                        -webkit-line-clamp: 1;
                        /* 显示的行数 */
                        overflow: hidden;
                        /* 隐藏溢出内容 */
                        text-overflow: ellipsis;
                        /* 显示省略号 */
                    }

                    p {
                        color: #4B5563;
                        font-size: 0.7rem;
                        display: -webkit-box;
                        /* 使用弹性盒子布局 */
                        -webkit-box-orient: vertical;
                        /* 设置内容垂直排列 */
                        -webkit-line-clamp: 2;
                        /* 限制显示的行数 */
                        overflow: hidden;
                        /* 隐藏超出部分 */
                        text-overflow: ellipsis;
                        /* 超出部分显示省略号 */
                    }
                }

                .Heziyun-linear {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #60A5FA 0%, #2563EB 100%);
                    width: 0%;
                    height: 0.15rem;
                }
            }

            .Heziyun-buy {
                color: #fff;
                background: linear-gradient(90deg, #1366EC 0%, #5DB5FF 100%);
                padding: 0.2rem 1rem;
            }
        }
    }
}

// 快捷方块1
@media (max-width: 768px) {
    .Heziyun-blockBackground {

        .Heziyun-quick {
            margin: 0;
            position: initial;
            gap: 3vw;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            padding: 5vw;
            background-color: #f3f5f8;

            .Heziyun-itemBlock {
                height: 20vw;
                width: 100%;
                background-color: rgba(228, 238, 255, 0.43);
                background-image: linear-gradient(0deg, #fff, #f3f5f8);
                border: 2px solid #fff;
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
                border-radius: 1vw;
                font-family: "思源黑";

                &:not(:last-child)::after {
                    display: none;
                }

                &:hover {
                    background-color: #fff;
                    height: 27vw;
                }

                .Heziyun-neirong {
                    position: relative;
                    height: 20vw;
                    padding: 3vw;
                    display: flex;
                    align-items: center;
                    gap: 2vw;

                    .Heziyun-picture {

                        :deep(.arco-image-img) {
                            width: 6vw;
                            height: 6vw;
                        }
                    }

                    .Heziyun-text {
                        gap: 1vw;

                        span {
                            font-size: 3.5vw;
                        }

                        p {
                            font-size: 3vw;
                            -webkit-line-clamp: 1;
                        }
                    }

                    .Heziyun-linear {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #60A5FA 0%, #2563EB 100%);
                        width: 0%;
                        height: 0.15rem;
                    }
                }

                .Heziyun-buy {
                    padding: 1vw 2vw;
                    font-size: 3.5vw;
                }
            }
        }

        .Heziyun-quick> :last-child:nth-child(odd) {
            grid-column: 1 / -1;
        }
    }
}
</style>